import { useEffect, useState } from 'react';
import {
  GetSignalingChannelEndpointCommand,
  GetSignalingChannelEndpointOutput,
  KinesisVideo,
  ResourceEndpointListItem,
} from '@aws-sdk/client-kinesis-video';
import { Role } from 'amazon-kinesis-video-streams-webrtc';
import {
  ERROR_CHANNEL_ARN_MISSING,
  ERROR_RESOURCE_ENDPOINT_LIST_MISSING,
} from './constants';
import { logger } from '../../../API/services/SharedService';

type SignalingChannelEndpoints = {
  WSS?: string;
  HTTPS?: string;
};

// Maps AWS KinesisVideo output to readable format.
function mapSignalingChannelEndpoints(
  data: GetSignalingChannelEndpointOutput,
): SignalingChannelEndpoints {
  if (!Array.isArray(data.ResourceEndpointList)) {
    throw new Error(ERROR_RESOURCE_ENDPOINT_LIST_MISSING);
  }

  const endpointsByProtocol = data.ResourceEndpointList.reduce(
    (
      endpoints: SignalingChannelEndpoints,
      endpoint: ResourceEndpointListItem,
    ) => {
      if (!endpoint.Protocol) {
        return endpoints;
      }
      endpoints[endpoint.Protocol as 'WSS' | 'HTTPS'] = endpoint.ResourceEndpoint;
      return endpoints;
    },
    <SignalingChannelEndpoints>{},
  );

  return <SignalingChannelEndpoints>endpointsByProtocol;
}

// Fetches signaling channel endpoints.
export function useSignalingChannelEndpoints(config: {
  channelARN: string;
  role: Role;
  kinesisVideoClient: KinesisVideo;
  retryCount?: any
}): {
    error: Error | undefined;
    signalingChannelEndpoints: SignalingChannelEndpoints | undefined;
  } {
  const {
    channelARN,
    kinesisVideoClient,
    role,
    retryCount,
  } = config;
  const [error, setError] = useState<Error>();
  const [signalingChannelEndpoints, setSignalingChannelEndpoints] = useState<SignalingChannelEndpoints>();

  if (!channelARN) {
    throw new Error(ERROR_CHANNEL_ARN_MISSING);
  }
  console.log(channelARN, role, kinesisVideoClient, 'logs for signalling');
  useEffect(() => {
    let isCancelled = false;

    const command = new GetSignalingChannelEndpointCommand({
      ChannelARN: channelARN,
      SingleMasterChannelEndpointConfiguration: {
        Protocols: ['WSS', 'HTTPS'],
        Role: role,
      },
    });
    console.log('calling video');
    kinesisVideoClient
      .send(command)
      .then(mapSignalingChannelEndpoints)
      .then((endpoints) => {
        if (isCancelled) {
          return;
        }
        setSignalingChannelEndpoints(endpoints);
      })
      .catch(
        logger.withErrorLog((err) => {
          if (isCancelled) {
            return;
          }
          setError(typeof err === 'string' ? new Error(err) : err);
        }),
      );

    return function cleanup() {
      isCancelled = true;
    };
  }, [channelARN, kinesisVideoClient, role, retryCount]);
  console.log(signalingChannelEndpoints, 'signalingChannelEndpoints');
  return { error, signalingChannelEndpoints };
}
